import React from 'react';

export default function CalendarUnreadBadge({ count }) {
  const total = Number(count || 0);
  if (total <= 0) return null;
  return (
    <span className="app-badge-count">
      {total > 99 ? '99+' : total}
    </span>
  );
}
